import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ForgotPassword from '../../../auth/forgot-password';
import tvtApi from '../../../services/tvt-api';

const OverviewInput = props => {
  return (
    <div className="overview-input-wrapper">
      <div className="overview-input-title ">{props.label}</div>
      <input
        className={
          props.disabled ? 'overview-input disabled' : 'overview-input'
        }
        disabled={props.disabled}
        onChange={props.onChange}
        value={props.value}
        type={props.type}
      />
      {props.children}
    </div>
  );
};

export const Overview = ({ user, selected, updateUser }) => {
  const [username, setUsername] = useState(user.username);
  if (!selected) {
    return null;
  }

  const onChangeUsername = e => {
    setUsername(e.target.value);
  };

  const formatDataRestrictions = () => {
    const restrictions = user.allowedDataCategories.filter(
      s => !s.includes('*')
    );

    const allowedMovies = user.allowedPages.includes('/movies');
    const allowedShows = user.allowedPages.includes('/shows');
    let titleAccess = '';
    let dataAccess = '';
    let formattedString = '';

    if (!allowedMovies && allowedShows) {
      titleAccess = 'Shows only';
    } else if (allowedMovies && !allowedShows) {
      titleAccess = 'Movies Only';
    } else if (allowedMovies && allowedShows) {
      titleAccess = 'Shows and Movies';
    }

    if (restrictions.length > 0) {
      dataAccess = restrictions.join(', ');
    }

    if (titleAccess.length && dataAccess.length) {
      formattedString = `${titleAccess} | ${dataAccess}`;
    } else if (titleAccess.length) {
      formattedString = `${titleAccess} | No Restrictions`;
    } else if (dataAccess.length) {
      formattedString = dataAccess;
    } else {
      formattedString = 'No Restrictions';
    }

    return formattedString;
  };

  const onSave = async () => {
    try {
      const res = await tvtApi.updateUsername(user.userId, username);
      updateUser(res);
    } catch (e) {
      console.log(e);
    }
  };

  const saveDisabled = () => username === user.username;

  return (
    <div className="user-data-overview">
      <OverviewInput
        label="Name"
        value={username}
        onChange={onChangeUsername}
      />
      <OverviewInput
        label="Organization"
        value={user.organization || 'N/A'}
        disabled
      />
      <OverviewInput label="Email" value={user.email || 'N/A'} disabled />
      <OverviewInput
        label="Password"
        type="password"
        value="FakePassword"
        disabled
      >
        <ForgotPassword
          title="Change Password"
          className="overview-input-action"
        />
      </OverviewInput>
      <OverviewInput
        label="Data Access/Restrictions"
        value={formatDataRestrictions()}
        disabled
      />
      <OverviewInput label="API Key" value={user.apiKey || 'N/A'} disabled />

      <div className="user-profile__overview-save-button-wrapper">
        <button
          disabled={saveDisabled()}
          className="user-profile__overview-save-button"
          onClick={onSave}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

Overview.propTypes = {
  selected: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    apiKey: PropTypes.string,
    username: PropTypes.string,
    organization: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    allowedDataCategories: PropTypes.arrayOf(PropTypes.string),
    allowedPages: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  updateUser: PropTypes.func.isRequired
};

OverviewInput.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  type: PropTypes.string,
  children: PropTypes.shape({}),
  onChange: PropTypes.func
};

OverviewInput.defaultProps = {
  disabled: false,
  type: '',
  children: null,
  onChange: () => {}
};

export default Overview;
